import type { Theme } from "@emotion/react";
import { createZfpTheme } from "@zfp-akademie-a-s/zfp-design";

// spacing and radius steps and the device widths come from the ZFP design package too
export {
  MOBILE_MAX_WIDTH,
  Radius,
  Spacing,
  TABLET_MAX_WIDTH,
} from "@zfp-akademie-a-s/zfp-design";

// The ZFP design from @zfp-akademie-a-s/zfp-design (palette, type, spacing, shadows and
// component styles), plus what only Analyzer has: its 72px toolbar and the theme variables
// its styled components read (theme.shadow, theme.borderRadius, theme.vh); colours come from the package's colors.
const theme = (): Theme => {
  const muiTheme = createZfpTheme({
    components: {
      MuiToolbar: {
        styleOverrides: {
          regular: {
            height: 72,
            minHeight: 72,
          },
        },
      },
    },
  });

  const customVariables = {
    shadow: {
      primary: "none",
      primaryHover: "0px 0px 15px 0px rgba(0, 0, 0, 0.15) inset",
    },
    borderRadius: "12px",
    vh: (val: number) => {
      return `calc(var(--vh, 1vh) * ${val})`;
    },
  };

  return Object.assign(muiTheme, customVariables) as Theme;
};

export const getTheme = () => {
  return theme();
};
